import { GraphService } from './services/graphs/GraphService';
import { VoteService } from './services/votes/VoteService';
import { PostService } from './services/posts/PostService';
import { StorageService } from './services/files/StorageService';
import { CommonService } from './services/common/CommonService';
import { CommentService } from './services/comments/CommentService';
import { SocialProviderTypes } from 'core/socialProviderTypes';
import { UserService } from './services/users/UserService';
import { AuthorizeService } from './services/authorize/AuthorizeService';
import { CircleService } from './services/circles/CircleService';
import { ImageGalleryService } from './services/imageGallery/ImageGalleryService';
import { NotificationService } from './services/notifications';
import { FirestoreClientTypes } from './firestoreClientTypes';
import { UserTieService } from './services/circles/UserTieService';
/**
 * Register firestore client dependecies
 * @param container DI container
 */
export var useFirestore = function (container) {
    container.bind(SocialProviderTypes.AuthorizeService).to(AuthorizeService);
    container.bind(SocialProviderTypes.CircleService).to(CircleService);
    container.bind(SocialProviderTypes.CommentService).to(CommentService);
    container.bind(SocialProviderTypes.CommonService).to(CommonService);
    container.bind(SocialProviderTypes.StorageService).to(StorageService);
    container.bind(SocialProviderTypes.ImageGalleryService).to(ImageGalleryService);
    container.bind(SocialProviderTypes.NotificationService).to(NotificationService);
    container.bind(SocialProviderTypes.PostService).to(PostService);
    container.bind(SocialProviderTypes.UserService).to(UserService);
    container.bind(SocialProviderTypes.VoteService).to(VoteService);
    container.bind(FirestoreClientTypes.GraphService).to(GraphService);
    container.bind(SocialProviderTypes.UserTieService).to(UserTieService);
};



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/dependecyRegisterar.ts
// module id = 594
// module chunks = 50